module.exports = __webpack_public_path__ + "img/backyard-wide.fa1dff92.webp";